/* Marisole cart drawer behaviour + shared cart API. No jQuery. */
(function () {
  if (!window.customElements) return;

  if (window.routes) {
    ['cart_add_url', 'cart_change_url', 'cart_update_url'].forEach(function (k) {
      if (routes[k] && routes[k].indexOf('.js') === -1) routes[k] += '.js';
    });
  }

  function ensureDrawerItems() {
    if (customElements.get('cart-drawer-items') || typeof CartItems === 'undefined') return;
    class MsCartDrawerItems extends CartItems {
      getSectionsToRender() {
        return [
          { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ];
      }
    }
    customElements.define('cart-drawer-items', MsCartDrawerItems);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureDrawerItems);
  } else {
    ensureDrawerItems();
  }

  /* ---- shared render + cart API ---- */
  function msSlideFill(node, fromWidth) {
    if (!node || node.__msAnimated) return;
    node.__msAnimated = true;
    var target = node.style.width;
    if (fromWidth == null || fromWidth === '' || fromWidth === target) return;
    node.style.transition = 'none';
    node.style.width = fromWidth;
    void node.offsetWidth;
    node.style.transition = '';
    var done = false;
    function commit() {
      if (done) return;
      done = true;
      node.style.width = target;
    }
    if (window.requestAnimationFrame) requestAnimationFrame(commit);
    setTimeout(commit, 60);
  }
  function msApplySections(st) {
    var drawer = document.querySelector('cart-drawer.ms-cart');
    if (st && st.sections && st.sections['cart-drawer'] && drawer) {
      var oldFill = drawer.querySelector('.ms-cart__fill');
      var oldWidth = oldFill ? oldFill.style.width : null;
      var doc = new DOMParser().parseFromString(st.sections['cart-drawer'], 'text/html');
      var next = doc.querySelector('.drawer__inner');
      var cur = drawer.querySelector('.drawer__inner');
      if (next && cur) {
        cur.innerHTML = next.innerHTML;
        cur.classList.toggle('is-empty', st.item_count === 0);
        msSlideFill(cur.querySelector('.ms-cart__fill'), oldWidth);
      }
      drawer.classList.toggle('is-empty', st.item_count === 0);
    }
    if (st && st.sections && st.sections['cart-icon-bubble']) {
      var bub = document.getElementById('cart-icon-bubble');
      if (bub) {
        var d2 = new DOMParser().parseFromString(st.sections['cart-icon-bubble'], 'text/html');
        var src = d2.querySelector('.shopify-section');
        if (src) bub.innerHTML = src.innerHTML;
      }
    }
    var live = document.getElementById('CartDrawer-LiveRegionText');
    if (live) {
      live.setAttribute('aria-hidden', 'false');
      live.textContent = 'Carrello aggiornato.';
      setTimeout(function () { live.setAttribute('aria-hidden', 'true'); }, 1200);
    }
  }
  function msOpenDrawer() {
    var drawer = document.querySelector('cart-drawer.ms-cart');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }
  window.MarisoleCart = {
    add: function (variantId, quantity) {
      return fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      }).then(function (st) {
        if (st.status && st.status !== 200) throw new Error('add-failed');
        msApplySections(st);
        msOpenDrawer();
        return st;
      });
    }
  };

  var msLastFill = null;
  var mo = new MutationObserver(function () {
    var f = document.querySelector('cart-drawer.ms-cart .ms-cart__fill');
    if (!f) { msLastFill = null; return; }
    var w = f.style.width;
    if (!f.__msAnimated && msLastFill != null && msLastFill !== w) {
      msSlideFill(f, msLastFill);
    }
    msLastFill = f.style.width;
  });
  function watchDrawer() {
    var d = document.querySelector('cart-drawer.ms-cart');
    if (d) mo.observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watchDrawer); } else { watchDrawer(); }

  var busy = false;
  function changeUrl() {
    return (window.routes && routes.cart_change_url) || '/cart/change.js';
  }
  function msUpdate(line, quantity) {
    if (busy) return;
    busy = true;
    var drawer = document.querySelector('cart-drawer.ms-cart');
    if (drawer) drawer.classList.add('ms-cart--busy');
    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(msApplySections)
      .catch(function () {})
      .finally(function () {
        busy = false;
        if (drawer) drawer.classList.remove('ms-cart--busy');
      });
  }
  function bindDrawer() {
    var drawer = document.querySelector('cart-drawer.ms-cart');
    if (!drawer || drawer.__msBound) return;
    drawer.__msBound = true;
    drawer.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('quantity__input')) return;
      e.stopImmediatePropagation();
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) { v = 1; input.value = '1'; }
      if (String(v) === input.dataset.cartQuantity) return;
      msUpdate(input.dataset.index, v);
    }, true);
    drawer.addEventListener('click', function (e) {
      var rem = e.target.closest ? e.target.closest('cart-remove-button') : null;
      if (rem) {
        e.preventDefault();
        e.stopImmediatePropagation();
        msUpdate(rem.dataset.index, 0);
      }
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDrawer);
  } else {
    bindDrawer();
  }
  document.addEventListener('shopify:section:load', bindDrawer);

  if (!customElements.get('ms-cart-timer')) {
    /* Reserveringsbalk.
       • Start op 10:00 zodra er minstens één product in de winkelwagen zit.
       • Telt elke seconde af tot 00:00 en verwijdert daarbij niets.
       • Blijft doorlopen binnen dezelfde browsersessie: het eindtijdstip staat
         in sessionStorage, dus sluiten en heropenen van de drawer reset niets.
       • Reset alleen wanneer de winkelwagen leeg is geweest en er daarna weer
         een product wordt toegevoegd.
       Teksten staan hier zodat sections/cart-drawer.liquid ongewijzigd blijft. */
    var MS_RESERVE_MINUTES = 10;
    var MS_RESERVE_KEY = 'ms_cart_reserved_until';
    var MS_LABEL_TEXT = 'I tuoi articoli sono riservati per:';
    var MS_EXPIRED_TEXT = 'La prenotazione è scaduta';

    class MsCartTimer extends HTMLElement {
      connectedCallback() {
        this.KEY = MS_RESERVE_KEY;
        var count = parseInt(this.dataset.itemCount || '0', 10);
        if (!count) {
          /* Lege winkelwagen: stempel wissen zodat een volgende toevoeging
             opnieuw op 10:00 begint. */
          try { sessionStorage.removeItem(this.KEY); } catch (e) {}
          this.hidden = true;
          return;
        }

        this.valueEl = this.querySelector('[data-timer-value]');
        this.labelEl = this.querySelector('[data-timer-label]');
        this.urgentEl = this.querySelector('[data-timer-urgent]');
        this.expiredEl = this.querySelector('[data-timer-expired]');
        if (this.labelEl) this.labelEl.textContent = MS_LABEL_TEXT;
        if (this.expiredEl) this.expiredEl.textContent = MS_EXPIRED_TEXT;

        var end = 0;
        try { end = parseInt(sessionStorage.getItem(this.KEY) || '0', 10); } catch (e) {}
        /* Alleen een nieuw venster openen als er nog geen loopt. Een bestaande
           (ook verlopen) stempel blijft staan, zodat heropenen of het wijzigen
           van aantallen de teller nooit terugzet. */
        if (!end) {
          end = Date.now() + MS_RESERVE_MINUTES * 60000;
          try { sessionStorage.setItem(this.KEY, String(end)); } catch (e) {}
        }
        this.end = end;

        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
      tick() {
        var left = this.end - Date.now();
        if (left <= 0) {
          if (this.timer) { clearInterval(this.timer); this.timer = null; }
          if (this.valueEl) this.valueEl.hidden = true;
          if (this.labelEl) this.labelEl.hidden = true;
          if (this.urgentEl) this.urgentEl.hidden = true;
          if (this.expiredEl) { this.expiredEl.textContent = MS_EXPIRED_TEXT; this.expiredEl.hidden = false; }
          this.classList.add('is-expired');
          return;
        }
        var m = Math.floor(left / 60000);
        var s = Math.floor((left % 60000) / 1000);
        if (this.valueEl) this.valueEl.textContent = (m < 10 ? '0' + m : '' + m) + ':' + (s < 10 ? '0' + s : '' + s);
        var urgent = left < 60000;
        if (this.urgentEl) this.urgentEl.hidden = !urgent;
        this.classList.toggle('is-urgent', urgent);
      }
    }
    customElements.define('ms-cart-timer', MsCartTimer);
  }
})();